module.exports = __webpack_public_path__ + "static/media/louis.bf4d97c6.jpg";